import styled from "styled-components/macro";

export default styled.div`
  color: ${({ theme }) => theme["@error"]};
  line-height: 2;
  font-size: 14px;
`;
